import React from "react";

import { formatPrice, getCost } from "../../common";

import { Button } from "components/Button";

import {
  DataCellTools,
  Table,
  TableContainer,
  TableHead,
  TableTitle,
  TableToolbarTitle,
  TitleCount,
} from "components/Table";

import { DataTableBody, DataTableCell, DataTableContent, DataTableRow } from "@rmwc/data-table";
import "@rmwc/data-table/styles";

import { Checkbox } from "@rmwc/checkbox";
import "@rmwc/checkbox/styles";

import Palette from "../../palette.json";
import { useHistory, useRouteMatch } from "react-router-dom";
import { useTask } from "hooks/params/useTask";
import { useProject } from "hooks/params/useProject";
import { TaskPartFields } from "types/admin/TaskPartFields";
import { TemplateFields_parts, TemplateFields_parts_items } from "types/admin/TemplateFields";
import { useTemplate } from "hooks/params/useTemplate";
import useTranslations from "hooks/useTranslations";

const totalStyle = {
  fontWeight: 500,
  fontSize: "16px",
};

interface PartListProps {
  items: (TaskPartFields | TemplateFields_parts_items | null)[];
  total?: number;
}

export const PartList: React.FC<PartListProps> = ({ items, total }) => {
  const { tCommon, tFeature } = useTranslations();
  const project = useProject();
  const { task } = useTask();
  const { template } = useTemplate();
  const history = useHistory();
  const match = useRouteMatch();

  if (!(project || task) && !template) return <></>;

  const cols: string[] = [
    tCommon("PartNumber"),
    "Description",
    "Quantity",
    "Unit Price",
    "Lead Time",
    "Billable",
    "Cost",
  ];

  return (
    <TableContainer>
      <TableTitle>
        <TableToolbarTitle>
          {tCommon("Parts")} <TitleCount>({items.length})</TitleCount>
        </TableToolbarTitle>

        <Button
          raised
          onClick={() =>
            history.push(
              template
                ? `/templates/${template.id}/tasks/${task?.id}/edit?tab=Parts`
                : `/work-orders/${project?.id}/tasks/${task?.id}/edit?tab=Parts`,
            )
          }
        >
          Manage
        </Button>
      </TableTitle>

      <Table>
        <DataTableContent>
          <TableHead {...{ cols }} />

          <DataTableBody data-test-id="part-list">
            {items.length === 0 && (
              <DataTableRow>
                <DataTableCell
                  colSpan={cols.length}
                  style={{ color: Palette.LightGrey, fontSize: "18px", textAlign: "center" }}
                >
                  - No Results -
                </DataTableCell>
              </DataTableRow>
            )}

            {items.map((it, i) => (
              <DataTableRow key={i}>
                <DataTableCell>{it?.number}</DataTableCell>
                <DataTableCell>{it?.name}</DataTableCell>
                <DataTableCell>{it?.quantity}</DataTableCell>
                <DataTableCell>{formatPrice(it?.cost as number)}</DataTableCell>
                <DataTableCell>{it?.leadTimeDays}</DataTableCell>
                <DataTableCell>
                  <Checkbox disabled checked={it?.isBillable || false} />
                </DataTableCell>
                <DataTableCell>{it?.isBillable ? formatPrice(getCost(it) as number) : "-"}</DataTableCell>
              </DataTableRow>
            ))}

            <DataTableRow>
              <DataTableCell style={totalStyle}>{tFeature("PartList.totalLabel")}</DataTableCell>
              {[...Array(cols.length - 2).keys()].map((col, i) => (
                <DataTableCell key={i} />
              ))}
              <DataTableCell style={totalStyle}>{formatPrice(total || 0)}</DataTableCell>
            </DataTableRow>
          </DataTableBody>
        </DataTableContent>
      </Table>
    </TableContainer>
  );
};
